<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.multiple" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="multiple" /><!--
          --><checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.disabled" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="disabled" /><!--
          --><checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.icon" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="icon" /><!--
          --><checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.expandCollapseIcon" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="expandCollapseIcon" />
        </test-toolbar>
      </flex-col>
      <flex-col :span="24">
        <card>
          <card-text>
            <collapsible
              :expand-collapse-icon="expandCollapseIcon"
              :multiple="multiple"
              v-if="rerendered"
              bg-color="transparent"
              :bg-color-lightness="null"
              :color="$dark ? 'white' : 'black'"
              :color-lightness="null"
              bg-color-expanded="gray"
              :bg-color-lightness-expanded="$dark ? 900 : 200"
              :color-expanded="$dark ? 'white' : 'black'"
              :color-lightness-expanded="null"
              :disabled="disabled">
              <collapsible-item @expand="onToggle('expand', $event)" @collapse="onToggle('collapse', $event)" v-for="(item, index) in items" :icon="icon ? item.icon : null" :key="index" :label="firstLetterCapital(item.icon).replace(/-/g, ' ')">
                <lorem-ipsum :repeats="3" />
              </collapsible-item>
            </collapsible>
          </card-text>
        </card>
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageCollapsible',
  data () {
    return {
      items: [],
      icon: true,
      disabled: false,
      multiple: true,
      rerendered: true,
      expandCollapseIcon: true
    }
  },
  mixins: [
    methods
  ],
  mounted () {
    this.getExternalData('collapsible.json', 'items')
  },
  watch: {
    multiple () {
      this.repaint()
    },
    expandCollapseIcon () {
      this.repaint()
    },
    $dark () {
      this.repaint()
    }
  },
  methods: {
    repaint () {
      this.rerendered = false
      this.$nextTick(() => {
        this.rerendered = true
      })
    },
    onToggle (event, data) {
      this.log(event, 'collapsible-item', data)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/collapsible.vue